import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

async function merchantGoldBalance(): Promise<any> {
    try {
        return (await axiosInstance.get("/merchant/GetGoldBalance"))
            .data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetMerchantGoldBalance() {
    return useMutation<any, Error>(
        () => merchantGoldBalance()
    );
}
